import { Calendar, UtensilsCrossed, MapPin, ShoppingBag } from 'lucide-react';
import appBookingsData from '../../../../data/appBookings/appBookingsData.json';

const iconMap = {
    Calendar,
    UtensilsCrossed,
    MapPin,
    ShoppingBag
};

const AppBookingsMetrics = ({ bookings = [] }) => {
    const getCount = (card) => {
        if (card.type === 'all') return bookings.length;
        if (Array.isArray(card.types)) {
            return bookings.filter(b => card.types.includes(b.type)).length;
        }
        return bookings.filter(b => b.type === card.type).length;
    };

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-5 mb-8">
            {appBookingsData.metrics.map((card) => {
                const Icon = iconMap[card.icon] || Calendar;
                const count = getCount(card);

                return (
                    <div
                        key={card.id || card.title}
                        className="bg-white rounded-2xl p-4 sm:p-5 border border-slate-100/90 shadow-xs flex items-center gap-4 hover:shadow-md transition-all"
                    >
                        <div className="w-11 h-11 rounded-full bg-emerald-50 text-[#067978] flex items-center justify-center shrink-0">
                            <Icon className="w-5 h-5 text-[#067978]" />
                        </div>
                        <div className="min-w-0 flex-1">
                            <p className="text-xs text-slate-500 font-medium">{card.title}</p>
                            <h3 className="text-2xl font-bold text-slate-900 mt-0.5">{count}</h3>
                            <p className="text-[11px] text-slate-400 font-normal mt-0.5 truncate">{card.subtitle}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default AppBookingsMetrics;
